// @ts-nocheck -- staged migration: add explicit types before removing this directive.
const kanjiDictionary = [
    {
        reading: "こんばんは",
        candidates: ["こんばんは"],
        romaji: "konbanwa",
        meanings: ["Good evening"],
        common: true
    },
    {
        reading: "こんにちは",
        candidates: ["こんにちは"],
        romaji: "konnichiwa",
        meanings: ["Hello"],
        common: true
    },
    {
        reading: "あお",
        candidates: ["青"]
    },
    {
        reading: "あおい",
        candidates: ["青い"]
    },
    {
        reading: "あか",
        candidates: ["赤"]
    },
    {
        reading: "あかい",
        candidates: ["赤い"]
    },
    {
        reading: "あたらしい",
        candidates: ["新しい"]
    },
    {
        reading: "あと",
        candidates: ["後"]
    },
    {
        reading: "あに",
        candidates: ["兄"]
    },
    {
        reading: "あね",
        candidates: ["姉"]
    },
    {
        reading: "あめ",
        candidates: ["雨"]
    },
    {
        reading: "いう",
        candidates: ["言う"]
    },
    {
        reading: "いえ",
        candidates: ["家"]
    },
    {
        reading: "いきます",
        candidates: ["行きます"]
    },
    {
        reading: "いく",
        candidates: ["行く"]
    },
    {
        reading: "いくら",
        candidates: ["幾ら"]
    },
    {
        reading: "いしや",
        candidates: ["医者"]
    },
    {
        reading: "いち",
        candidates: ["一"]
    },
    {
        reading: "いつ",
        candidates: ["五つ"]
    },
    {
        reading: "いつか",
        candidates: ["五日"]
    },
    {
        reading: "いま",
        candidates: ["今"]
    },
    {
        reading: "いもうと",
        candidates: ["妹"]
    },
    {
        reading: "いりぐち",
        candidates: ["入口"]
    },
    {
        reading: "いれる",
        candidates: ["入れる"]
    },
    {
        reading: "いる",
        candidates: ["居る", "要る"]
    },
    {
        reading: "うえ",
        candidates: ["上"]
    },
    {
        reading: "うしろ",
        candidates: ["後ろ"]
    },
    {
        reading: "うた",
        candidates: ["歌"]
    },
    {
        reading: "うまれる",
        candidates: ["生まれる"]
    },
    {
        reading: "うみ",
        candidates: ["海"]
    },
    {
        reading: "うる",
        candidates: ["売る"]
    },
    {
        reading: "えいが",
        candidates: ["映画"]
    },
    {
        reading: "えいご",
        candidates: ["英語"]
    },
    {
        reading: "えき",
        candidates: ["駅"]
    },
    {
        reading: "えん",
        candidates: ["円"]
    },
    {
        reading: "おいしい",
        candidates: ["美味しい"]
    },
    {
        reading: "おおきい",
        candidates: ["大きい"]
    },
    {
        reading: "おおきな",
        candidates: ["大きな"]
    },
    {
        reading: "おかあさん",
        candidates: ["お母さん"]
    },
    {
        reading: "おかね",
        candidates: ["お金"]
    },
    {
        reading: "おきる",
        candidates: ["起きる"]
    },
    {
        reading: "おく",
        candidates: ["置く"]
    },
    {
        reading: "おくさん",
        candidates: ["奥さん"]
    },
    {
        reading: "おさけ",
        candidates: ["お酒"]
    },
    {
        reading: "おとうさん",
        candidates: ["お父さん"]
    },
    {
        reading: "おとうと",
        candidates: ["弟"]
    },
    {
        reading: "おとこ",
        candidates: ["男"]
    },
    {
        reading: "おとこのこ",
        candidates: ["男の子"]
    },
    {
        reading: "おんな",
        candidates: ["女"]
    },
    {
        reading: "おんなのこ",
        candidates: ["女の子"]
    },
    {
        reading: "か",
        candidates: ["火", "科"]
    },
    {
        reading: "がいこく",
        candidates: ["外国"]
    },
    {
        reading: "がいこくじん",
        candidates: ["外国人"]
    },
    {
        reading: "かいしゃ",
        candidates: ["会社"]
    },
    {
        reading: "かう",
        candidates: ["買う"]
    },
    {
        reading: "かえる",
        candidates: ["帰る"]
    },
    {
        reading: "かがく",
        candidates: ["科学"]
    },
    {
        reading: "がく",
        candidates: ["学"]
    },
    {
        reading: "がくせい",
        candidates: ["学生"]
    },
    {
        reading: "かく",
        candidates: ["書く"]
    },
    {
        reading: "かげつ",
        candidates: ["か月"]
    },
    {
        reading: "かさ",
        candidates: ["傘"]
    },
    {
        reading: "かじ",
        candidates: ["家事"]
    },
    {
        reading: "かぞく",
        candidates: ["家族"]
    },
    {
        reading: "かた",
        candidates: ["方"]
    },
    {
        reading: "がっこう",
        candidates: ["学校"]
    },
    {
        reading: "かど",
        candidates: ["角"]
    },
    {
        reading: "かな",
        candidates: ["仮名"]
    },
    {
        reading: "かのじょ",
        candidates: ["彼女"]
    },
    {
        reading: "かばん",
        candidates: ["鞄"]
    },
    {
        reading: "かびん",
        candidates: ["花瓶"]
    },
    {
        reading: "かようび",
        candidates: ["火曜日"]
    },
    {
        reading: "からだ",
        candidates: ["体"]
    },
    {
        reading: "かわ",
        candidates: ["川"]
    },
    {
        reading: "かん",
        candidates: ["間"]
    },
    {
        reading: "かんじ",
        candidates: ["漢字"]
    },
    {
        reading: "き",
        candidates: ["木", "気"]
    },
    {
        reading: "きいろ",
        candidates: ["黄色"]
    },
    {
        reading: "きく",
        candidates: ["聞く"]
    },
    {
        reading: "きた",
        candidates: ["北"]
    },
    {
        reading: "きっさてん",
        candidates: ["喫茶店"]
    },
    {
        reading: "きって",
        candidates: ["切手"]
    },
    {
        reading: "きっぷ",
        candidates: ["切符"]
    },
    {
        reading: "きのう",
        candidates: ["昨日"]
    },
    {
        reading: "きょう",
        candidates: ["今日", "京"]
    },
    {
        reading: "きょうしつ",
        candidates: ["教室"]
    },
    {
        reading: "きょうだい",
        candidates: ["兄弟"]
    },
    {
        reading: "きょねん",
        candidates: ["去年"]
    },
    {
        reading: "きらい",
        candidates: ["嫌い"]
    },
    {
        reading: "きる",
        candidates: ["切る", "着る"]
    },
    {
        reading: "きん",
        candidates: ["金"]
    },
    {
        reading: "ぎんこう",
        candidates: ["銀行"]
    },
    {
        reading: "く",
        candidates: ["九"]
    },
    {
        reading: "くがつ",
        candidates: ["九月"]
    },
    {
        reading: "くに",
        candidates: ["国"]
    },
    {
        reading: "くもり",
        candidates: ["曇り"]
    },
    {
        reading: "くる",
        candidates: ["来る"]
    },
    {
        reading: "くるま",
        candidates: ["車"]
    },
    {
        reading: "げつ",
        candidates: ["月"]
    },
    {
        reading: "げつようび",
        candidates: ["月曜日"]
    },
    {
        reading: "げんかん",
        candidates: ["玄関"]
    },
    {
        reading: "こ",
        candidates: ["子"]
    },
    {
        reading: "こう",
        candidates: ["校"]
    },
    {
        reading: "ご",
        candidates: ["語", "五", "後"]
    },
    {
        reading: "こうえん",
        candidates: ["公園"]
    },
    {
        reading: "ごご",
        candidates: ["午後"]
    },
    {
        reading: "ここのか",
        candidates: ["九日"]
    },
    {
        reading: "ここのつ",
        candidates: ["九つ"]
    },
    {
        reading: "ごぜん",
        candidates: ["午前"]
    },
    {
        reading: "こたえる",
        candidates: ["答える"]
    },
    {
        reading: "こちら",
        candidates: ["此方"]
    },
    {
        reading: "ことし",
        candidates: ["今年"]
    },
    {
        reading: "ことば",
        candidates: ["言葉"]
    },
    {
        reading: "こども",
        candidates: ["子供"]
    },
    {
        reading: "このあいだ",
        candidates: ["この間"]
    },
    {
        reading: "ごはん",
        candidates: ["ご飯"]
    },
    {
        reading: "こまる",
        candidates: ["困る"]
    },
    {
        reading: "こんげつ",
        candidates: ["今月"]
    },
    {
        reading: "こんしゅう",
        candidates: ["今週"]
    },
    {
        reading: "こんにち",
        candidates: ["今日"]
    },
    {
        reading: "こんばん",
        candidates: ["今晩"]
    },
    {
        reading: "さい",
        candidates: ["歳"]
    },
    {
        reading: "さかな",
        candidates: ["魚"]
    },
    {
        reading: "さき",
        candidates: ["先"]
    },
    {
        reading: "さく",
        candidates: ["咲く"]
    },
    {
        reading: "さくぶん",
        candidates: ["作文"]
    },
    {
        reading: "さす",
        candidates: ["差す"]
    },
    {
        reading: "ざっし",
        candidates: ["雑誌"]
    },
    {
        reading: "さとう",
        candidates: ["砂糖"]
    },
    {
        reading: "さむい",
        candidates: ["寒い"]
    },
    {
        reading: "さん",
        candidates: ["三", "山"]
    },
    {
        reading: "さんぽ",
        candidates: ["散歩"]
    },
    {
        reading: "し",
        candidates: ["四"]
    },
    {
        reading: "じ",
        candidates: ["時", "字"]
    },
    {
        reading: "しお",
        candidates: ["塩"]
    },
    {
        reading: "しかし",
        candidates: ["然し"]
    },
    {
        reading: "じかん",
        candidates: ["時間"]
    },
    {
        reading: "しがつ",
        candidates: ["四月"]
    },
    {
        reading: "しごと",
        candidates: ["仕事"]
    },
    {
        reading: "じしょ",
        candidates: ["辞書"]
    },
    {
        reading: "しち",
        candidates: ["七"]
    },
    {
        reading: "しちがつ",
        candidates: ["七月"]
    },
    {
        reading: "しつもん",
        candidates: ["質問"]
    },
    {
        reading: "じてんしゃ",
        candidates: ["自転車"]
    },
    {
        reading: "じどうしゃ",
        candidates: ["自動車"]
    },
    {
        reading: "しぬ",
        candidates: ["死ぬ"]
    },
    {
        reading: "じびき",
        candidates: ["字引"]
    },
    {
        reading: "じぶん",
        candidates: ["自分"]
    },
    {
        reading: "しまる",
        candidates: ["閉まる"]
    },
    {
        reading: "しめる",
        candidates: ["閉める"]
    },
    {
        reading: "しも",
        candidates: ["下"]
    },
    {
        reading: "しゃしん",
        candidates: ["写真"]
    },
    {
        reading: "じゃあく",
        candidates: ["邪悪"]
    },
    {
        reading: "じゅう",
        candidates: ["十"]
    },
    {
        reading: "じゅうがつ",
        candidates: ["十月"]
    },
    {
        reading: "じゅうよっか",
        candidates: ["十四日"]
    },
    {
        reading: "じゅぎょう",
        candidates: ["授業"]
    },
    {
        reading: "しゅくだい",
        candidates: ["宿題"]
    },
    {
        reading: "しゅじん",
        candidates: ["主人"]
    },
    {
        reading: "しゅっせき",
        candidates: ["出席"]
    },
    {
        reading: "しゅっぱつ",
        candidates: ["出発"]
    },
    {
        reading: "しょくどう",
        candidates: ["食堂"]
    },
    {
        reading: "しる",
        candidates: ["知る"]
    },
    {
        reading: "しろ",
        candidates: ["白"]
    },
    {
        reading: "しろい",
        candidates: ["白い"]
    },
    {
        reading: "しんぶん",
        candidates: ["新聞"]
    },
    {
        reading: "すい",
        candidates: ["水"]
    },
    {
        reading: "すいようび",
        candidates: ["水曜日"]
    },
    {
        reading: "すう",
        candidates: ["数"]
    },
    {
        reading: "すき",
        candidates: ["好き"]
    },
    {
        reading: "すくない",
        candidates: ["少ない"]
    },
    {
        reading: "すむ",
        candidates: ["住む"]
    },
    {
        reading: "する",
        candidates: ["する"]
    },
    {
        reading: "せ",
        candidates: ["背"]
    },
    {
        reading: "せい",
        candidates: ["生"]
    },
    {
        reading: "せいと",
        candidates: ["生徒"]
    },
    {
        reading: "せかい",
        candidates: ["世界"]
    },
    {
        reading: "せん",
        candidates: ["千", "先"]
    },
    {
        reading: "せんげつ",
        candidates: ["先月"]
    },
    {
        reading: "せんしゅう",
        candidates: ["先週"]
    },
    {
        reading: "せんせい",
        candidates: ["先生"]
    },
    {
        reading: "せんもん",
        candidates: ["専門"]
    },
    {
        reading: "そうじ",
        candidates: ["掃除"]
    },
    {
        reading: "そこ",
        candidates: ["其処"]
    },
    {
        reading: "そと",
        candidates: ["外"]
    },
    {
        reading: "そら",
        candidates: ["空"]
    },
    {
        reading: "だいがく",
        candidates: ["大学"]
    },
    {
        reading: "だいどころ",
        candidates: ["台所"]
    },
    {
        reading: "たいへん",
        candidates: ["大変"]
    },
    {
        reading: "たかい",
        candidates: ["高い"]
    },
    {
        reading: "たくさん",
        candidates: ["沢山"]
    },
    {
        reading: "だす",
        candidates: ["出す"]
    },
    {
        reading: "たちます",
        candidates: ["立ちます"]
    },
    {
        reading: "たつ",
        candidates: ["立つ"]
    },
    {
        reading: "たて",
        candidates: ["縦"]
    },
    {
        reading: "たのしい",
        candidates: ["楽しい"]
    },
    {
        reading: "たべる",
        candidates: ["食べる"],
        romaji: "taberu",
        meanings: ["To eat"],
        common: true
    },
    {
        reading: "たべます",
        candidates: ["食べます"]
    },
    {
        reading: "たまご",
        candidates: ["卵"]
    },
    {
        reading: "だれ",
        candidates: ["誰"]
    },
    {
        reading: "たんじょうび",
        candidates: ["誕生日"]
    },
    {
        reading: "ちいさい",
        candidates: ["小さい"]
    },
    {
        reading: "ちいさな",
        candidates: ["小さな"]
    },
    {
        reading: "ちかい",
        candidates: ["近い"]
    },
    {
        reading: "ちかく",
        candidates: ["近く"]
    },
    {
        reading: "ちかてつ",
        candidates: ["地下鉄"]
    },
    {
        reading: "ちち",
        candidates: ["父"]
    },
    {
        reading: "ちゃいろ",
        candidates: ["茶色"]
    },
    {
        reading: "ちゅう",
        candidates: ["中"]
    },
    {
        reading: "ちゅうがく",
        candidates: ["中学"]
    },
    {
        reading: "ちゅうごく",
        candidates: ["中国"]
    },
    {
        reading: "ちょう",
        candidates: ["長"]
    },
    {
        reading: "ついたち",
        candidates: ["一日"]
    },
    {
        reading: "つかう",
        candidates: ["使う"]
    },
    {
        reading: "つかれる",
        candidates: ["疲れる"]
    },
    {
        reading: "つき",
        candidates: ["月"]
    },
    {
        reading: "つく",
        candidates: ["着く"]
    },
    {
        reading: "つくえ",
        candidates: ["机"]
    },
    {
        reading: "つくる",
        candidates: ["作る"]
    },
    {
        reading: "つち",
        candidates: ["土"]
    },
    {
        reading: "つまらない",
        candidates: ["詰まらない"]
    },
    {
        reading: "つよい",
        candidates: ["強い"]
    },
    {
        reading: "て",
        candidates: ["手"]
    },
    {
        reading: "テスト",
        candidates: ["テスト"]
    },
    {
        reading: "でかける",
        candidates: ["出かける"]
    },
    {
        reading: "てがみ",
        candidates: ["手紙"]
    },
    {
        reading: "できる",
        candidates: ["出来る"]
    },
    {
        reading: "でぐち",
        candidates: ["出口"]
    },
    {
        reading: "テーブル",
        candidates: ["テーブル"]
    },
    {
        reading: "でる",
        candidates: ["出る"]
    },
    {
        reading: "てん",
        candidates: ["天", "店"]
    },
    {
        reading: "てんき",
        candidates: ["天気"]
    },
    {
        reading: "でんき",
        candidates: ["電気"]
    },
    {
        reading: "でんしゃ",
        candidates: ["電車"]
    },
    {
        reading: "でんわ",
        candidates: ["電話"]
    },
    {
        reading: "と",
        candidates: ["戸", "十"]
    },
    {
        reading: "どう",
        candidates: ["道"]
    },
    {
        reading: "とお",
        candidates: ["十"]
    },
    {
        reading: "とおい",
        candidates: ["遠い"]
    },
    {
        reading: "とおか",
        candidates: ["十日"]
    },
    {
        reading: "とき",
        candidates: ["時"]
    },
    {
        reading: "とけい",
        candidates: ["時計"]
    },
    {
        reading: "ところ",
        candidates: ["所"]
    },
    {
        reading: "としょかん",
        candidates: ["図書館"]
    },
    {
        reading: "となり",
        candidates: ["隣"]
    },
    {
        reading: "とぶ",
        candidates: ["飛ぶ"]
    },
    {
        reading: "とまる",
        candidates: ["止まる", "泊まる"]
    },
    {
        reading: "ともだち",
        candidates: ["友達"]
    },
    {
        reading: "どようび",
        candidates: ["土曜日"]
    },
    {
        reading: "とり",
        candidates: ["鳥"]
    },
    {
        reading: "とる",
        candidates: ["取る", "撮る"]
    },
    {
        reading: "なか",
        candidates: ["中"]
    },
    {
        reading: "ながい",
        candidates: ["長い"]
    },
    {
        reading: "なな",
        candidates: ["七"]
    },
    {
        reading: "ななつ",
        candidates: ["七つ"]
    },
    {
        reading: "なのか",
        candidates: ["七日"]
    },
    {
        reading: "なに",
        candidates: ["何"]
    },
    {
        reading: "なん",
        candidates: ["何"]
    },
    {
        reading: "に",
        candidates: ["二"]
    },
    {
        reading: "にく",
        candidates: ["肉"]
    },
    {
        reading: "にし",
        candidates: ["西"]
    },
    {
        reading: "にち",
        candidates: ["日"]
    },
    {
        reading: "にちようび",
        candidates: ["日曜日"]
    },
    {
        reading: "にもつ",
        candidates: ["荷物"]
    },
    {
        reading: "にゅうがく",
        candidates: ["入学"]
    },
    {
        reading: "にん",
        candidates: ["人"]
    },
    {
        reading: "にんげん",
        candidates: ["人間"]
    },
    {
        reading: "ぬぐ",
        candidates: ["脱ぐ"]
    },
    {
        reading: "ねん",
        candidates: ["年"]
    },
    {
        reading: "のみます",
        candidates: ["飲みます"]
    },
    {
        reading: "のむ",
        candidates: ["飲む"],
        romaji: "nomu",
        meanings: ["To drink"],
        common: true
    },
    {
        reading: "のる",
        candidates: ["乗る"]
    },
    {
        reading: "は",
        candidates: ["歯"]
    },
    {
        reading: "パーティー",
        candidates: ["パーティー"]
    },
    {
        reading: "はい",
        candidates: ["はい"]
    },
    {
        reading: "はいる",
        candidates: ["入る"]
    },
    {
        reading: "はく",
        candidates: ["履く"]
    },
    {
        reading: "はこ",
        candidates: ["箱"]
    },
    {
        reading: "はし",
        candidates: ["橋", "箸"]
    },
    {
        reading: "はしる",
        candidates: ["走る"]
    },
    {
        reading: "バス",
        candidates: ["バス"]
    },
    {
        reading: "はたち",
        candidates: ["二十歳"]
    },
    {
        reading: "はたらく",
        candidates: ["働く"]
    },
    {
        reading: "はっか",
        candidates: ["八日"]
    },
    {
        reading: "はな",
        candidates: ["花", "鼻"]
    },
    {
        reading: "はなす",
        candidates: ["話す"]
    },
    {
        reading: "はなせます",
        candidates: ["話せます"]
    },
    {
        reading: "はは",
        candidates: ["母"]
    },
    {
        reading: "はやい",
        candidates: ["早い", "速い"]
    },
    {
        reading: "はる",
        candidates: ["春"]
    },
    {
        reading: "ばん",
        candidates: ["晩"]
    },
    {
        reading: "ばんごう",
        candidates: ["番号"]
    },
    {
        reading: "ひ",
        candidates: ["火", "日"]
    },
    {
        reading: "ひがし",
        candidates: ["東"]
    },
    {
        reading: "ひく",
        candidates: ["引く", "弾く"]
    },
    {
        reading: "ひこうき",
        candidates: ["飛行機"]
    },
    {
        reading: "ひだり",
        candidates: ["左"]
    },
    {
        reading: "ひと",
        candidates: ["人"]
    },
    {
        reading: "ひとつ",
        candidates: ["一つ"]
    },
    {
        reading: "ひとり",
        candidates: ["一人"]
    },
    {
        reading: "ひゃく",
        candidates: ["百"]
    },
    {
        reading: "びょういん",
        candidates: ["病院"]
    },
    {
        reading: "ひる",
        candidates: ["昼"]
    },
    {
        reading: "ひるごはん",
        candidates: ["昼ご飯"]
    },
    {
        reading: "ひろい",
        candidates: ["広い"]
    },
    {
        reading: "ふたつ",
        candidates: ["二つ"]
    },
    {
        reading: "ふたり",
        candidates: ["二人"]
    },
    {
        reading: "ふつか",
        candidates: ["二日"]
    },
    {
        reading: "ふゆ",
        candidates: ["冬"]
    },
    {
        reading: "ふるい",
        candidates: ["古い"]
    },
    {
        reading: "べんきょう",
        candidates: ["勉強"]
    },
    {
        reading: "べんり",
        candidates: ["便利"]
    },
    {
        reading: "ほう",
        candidates: ["方"]
    },
    {
        reading: "ぼうし",
        candidates: ["帽子"]
    },
    {
        reading: "ほか",
        candidates: ["外"]
    },
    {
        reading: "ほしい",
        candidates: ["欲しい"]
    },
    {
        reading: "ほそい",
        candidates: ["細い"]
    },
    {
        reading: "ほん",
        candidates: ["本"]
    },
    {
        reading: "ほんとう",
        candidates: ["本当"]
    },
    {
        reading: "まいあさ",
        candidates: ["毎朝"]
    },
    {
        reading: "まいげつ",
        candidates: ["毎月"]
    },
    {
        reading: "まいしゅう",
        candidates: ["毎週"]
    },
    {
        reading: "まいにち",
        candidates: ["毎日"]
    },
    {
        reading: "まいねん",
        candidates: ["毎年"]
    },
    {
        reading: "まいばん",
        candidates: ["毎晩"]
    },
    {
        reading: "まえ",
        candidates: ["前"]
    },
    {
        reading: "まがる",
        candidates: ["曲がる"]
    },
    {
        reading: "まち",
        candidates: ["町"]
    },
    {
        reading: "まつ",
        candidates: ["待つ"]
    },
    {
        reading: "まど",
        candidates: ["窓"]
    },
    {
        reading: "まるい",
        candidates: ["丸い"]
    },
    {
        reading: "まん",
        candidates: ["万"]
    },
    {
        reading: "みぎ",
        candidates: ["右"]
    },
    {
        reading: "みじかい",
        candidates: ["短い"]
    },
    {
        reading: "みず",
        candidates: ["水"]
    },
    {
        reading: "みせ",
        candidates: ["店"]
    },
    {
        reading: "みち",
        candidates: ["道"]
    },
    {
        reading: "みっか",
        candidates: ["三日"],
        meanings: ["Third day of the month", "Three days"]
    },
    {
        reading: "みっつ",
        candidates: ["三つ"]
    },
    {
        reading: "みなみ",
        candidates: ["南"]
    },
    {
        reading: "みる",
        candidates: ["見る"]
    },
    {
        reading: "むいか",
        candidates: ["六日"]
    },
    {
        reading: "むこう",
        candidates: ["向こう"]
    },
    {
        reading: "むずかしい",
        candidates: ["難しい"]
    },
    {
        reading: "むっつ",
        candidates: ["六つ"]
    },
    {
        reading: "め",
        candidates: ["目"]
    },
    {
        reading: "めい",
        candidates: ["名"]
    },
    {
        reading: "めがね",
        candidates: ["眼鏡"]
    },
    {
        reading: "もう",
        candidates: ["もう"]
    },
    {
        reading: "もく",
        candidates: ["木"]
    },
    {
        reading: "もくようび",
        candidates: ["木曜日"]
    },
    {
        reading: "もの",
        candidates: ["物"]
    },
    {
        reading: "もつ",
        candidates: ["持つ"]
    },
    {
        reading: "もん",
        candidates: ["門"]
    },
    {
        reading: "もんだい",
        candidates: ["問題"]
    },
    {
        reading: "やおや",
        candidates: ["八百屋"]
    },
    {
        reading: "やく",
        candidates: ["約"]
    },
    {
        reading: "やくそく",
        candidates: ["約束"]
    },
    {
        reading: "やすい",
        candidates: ["安い"]
    },
    {
        reading: "やすみ",
        candidates: ["休み"]
    },
    {
        reading: "やすむ",
        candidates: ["休む"]
    },
    {
        reading: "やま",
        candidates: ["山"]
    },
    {
        reading: "ゆうがた",
        candidates: ["夕方"]
    },
    {
        reading: "ゆうびんきょく",
        candidates: ["郵便局"]
    },
    {
        reading: "ゆうめい",
        candidates: ["有名"]
    },
    {
        reading: "ゆき",
        candidates: ["雪"]
    },
    {
        reading: "ようか",
        candidates: ["八日"]
    },
    {
        reading: "ようび",
        candidates: ["曜日"]
    },
    {
        reading: "よい",
        candidates: ["良い"]
    },
    {
        reading: "ようふく",
        candidates: ["洋服"]
    },
    {
        reading: "よく",
        candidates: ["良く"]
    },
    {
        reading: "よこ",
        candidates: ["横"]
    },
    {
        reading: "よっか",
        candidates: ["四日"]
    },
    {
        reading: "よっつ",
        candidates: ["四つ"]
    },
    {
        reading: "よぶ",
        candidates: ["呼ぶ"]
    },
    {
        reading: "よむ",
        candidates: ["読む"]
    },
    {
        reading: "らいげつ",
        candidates: ["来月"]
    },
    {
        reading: "らいしゅう",
        candidates: ["来週"]
    },
    {
        reading: "らいねん",
        candidates: ["来年"]
    },
    {
        reading: "りっぱ",
        candidates: ["立派"]
    },
    {
        reading: "りゅうがくせい",
        candidates: ["留学生"]
    },
    {
        reading: "りょうしん",
        candidates: ["両親"]
    },
    {
        reading: "りょうり",
        candidates: ["料理"]
    },
    {
        reading: "れいぞうこ",
        candidates: ["冷蔵庫"]
    },
    {
        reading: "れんしゅう",
        candidates: ["練習"]
    },
    {
        reading: "ろく",
        candidates: ["六"]
    },
    {
        reading: "ろっか",
        candidates: ["六日"]
    },
    {
        reading: "わかい",
        candidates: ["若い"]
    },
    {
        reading: "わかる",
        candidates: ["分かる"]
    },
    {
        reading: "わすれる",
        candidates: ["忘れる"]
    },
    {
        reading: "わたし",
        candidates: ["私"]
    },
    {
        reading: "わたる",
        candidates: ["渡る"]
    }
]

export default kanjiDictionary
